import { useZendeskApi } from '@shared/lib/zendesk/hooks';
import { useCallback, useEffect } from 'react';
import useHelpKeywords from './help/useHelpKeywords';

const useZendesk = (isOpen: boolean, toggleHelpVisibility: (visible: boolean) => void) => {
  const zendesk = useZendeskApi();
  const helpKeywords = useHelpKeywords();
  const handleClose = useCallback(() => toggleHelpVisibility(false), [toggleHelpVisibility]);

  useEffect(() => {
    zendesk.on('close', handleClose);
    return () => {
      zendesk.off('close', handleClose);
    };
  }, [handleClose, zendesk]);

  useEffect(() => {
    if (isOpen) {
      zendesk.showWidget(helpKeywords);
    } else {
      zendesk.hideWidget();
    }
  }, [helpKeywords, isOpen, zendesk]);
};

export default useZendesk;
